import { useResponseLength } from './ResponseLengthContext';
import { useT } from '../I18nContext';

/**
 * Segmented control on the rail. "Standard" / "Detailed" sets the
 * `response_length` field that the Composer's send mutation passes
 * to /api/chat. Standard is shorter / faster; Detailed asks the
 * model for a more thorough answer.
 *
 * Two buttons on a shared track - same pattern as the legacy
 * template's `.segmented` group, restyled to match the dashboard
 * tokens.
 */
export function ResponseLengthToggle() {
  const { length, setLength } = useResponseLength();
  const t = useT();

  return (
    <div
      className="response-length-toggle"
      role="group"
      aria-label={t('response_length.group_label')}
    >
      <button
        type="button"
        className={
          'response-length-toggle-btn' +
          (length === 'standard' ? ' is-active' : '')
        }
        onClick={() => setLength('standard')}
        aria-pressed={length === 'standard'}
      >
        {t('response_length.standard')}
      </button>
      <button
        type="button"
        className={
          'response-length-toggle-btn' +
          (length === 'long' ? ' is-active' : '')
        }
        onClick={() => setLength('long')}
        aria-pressed={length === 'long'}
      >
        {t('response_length.detailed')}
      </button>
    </div>
  );
}
